import h from 'react-hyperscript';
import { Link } from 'react-router-dom';

import pkgJson from '../../../package.json';
import { routeMap } from '../../routes';

const { config: { shortName: companyNameShort } } = pkgJson;

export default () => {
  const subscriptionRoutePath = routeMap.USER_SETTINGS_SUBSCRIPTION.path;

  return h('.card.border-primary', [
    h('.card-header', [h('h4', 'Your subscription has ended')]),
    h('.card-block', [
      h('.card-body', [
        "All good things come to an end, but they don't have to. Restart your subscription today and you will instantly be back to event management bliss.",
      ]),
      h('br'),
      h('.text-center', [
        h(Link, { className: 'btn btn-primary', to: subscriptionRoutePath }, `Continue using ${companyNameShort}`),
      ]),
      h('br'),
      h('.text-center', [
        h('div', [
          'Re-subscribe to make managing your events a piece of \uD83C\uDF70 \u00A0again.',
          h('i', " I mean who doesn't like cake?"),
        ]),
      ]),
    ]),
  ]);
};



// WEBPACK FOOTER //
// ./src/components/Card/CardSubscriptionEnded.js